import { gql } from '@apollo/client';
import { COHORT_SUMMARY } from '../fragments';

/**
 * `createdBy` comes from the token, not from a nested connect.
 *
 * The selection is the list's own fragment because the result is written
 * into the list's cache entry, and a narrower selection there makes Apollo
 * refuse the write.
 */
export const CREATE_COHORT = gql`
  mutation createCohort($input: CreateCohortInputType!) {
    createCohort(input: $input) {
      ...CohortSummary
    }
  }
  ${COHORT_SUMMARY}
`;

export const DELETE_COHORT = gql`
  mutation deleteCohort($id: String!) {
    deleteCohort(id: $id)
  }
`;
